"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("../NotificationBannerInline/constant");

var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    theme: _propTypes.string,
    isShow: _propTypes.bool.isRequired,
    message: (0, _propTypes.oneOfType)([_propTypes.string.isRequired, (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      text: _propTypes.string.isRequired,
      cta: _propTypes.string,
      url: _propTypes.string,
      newTab: _propTypes.string
    }))]),
    autoHideDuration: _propTypes.number,
    onClose: _propTypes.func,
    topPosition: _propTypes.number,
    zIndex: _propTypes.number,
    isMobile: _propTypes.bool,
    showLeftIcon: _propTypes.bool,
    type: (0, _propTypes.oneOf)(_constant2.Types),
    isClosable: _propTypes.bool,
    showOnTopMobile: _propTypes.bool,
    ctaColor: _propTypes.string,
    ctaSize: _propTypes.string,
    isBannerClickable: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    autoHideDuration: null,
    onClose: function onClose() {},
    zIndex: 9,
    showLeftIcon: false,
    type: 'info',
    isClosable: true,
    showOnTopMobile: false,
    isBannerClickable: true
  }
};
exports.default = _default;